import { apiClient } from "@/lib/api-client";

export interface User {
    user_id: string;
    email: string;
    first_name?: string;
    last_name?: string;
    full_name?: string;
    user_role: string;
    company_id?: string;
    is_active: boolean;
    email_verified: boolean;
    created_at: string;
    updated_at: string;
}

export interface UserFilters {
    company_id?: string;
    user_role?: string;
    is_active?: boolean;
    skip?: number;
    limit?: number;
}

/**
 * Get list of users with optional filters
 */
export async function getUsers(filters?: UserFilters): Promise<User[]> {
    const params: Record<string, string | number | boolean> = {};
    
    if (filters?.company_id) {
        params.company_id = filters.company_id;
    }
    if (filters?.user_role) {
        params.user_role = filters.user_role;
    }
    if (filters?.is_active !== undefined) {
        params.is_active = filters.is_active;
    }
    if (filters?.skip !== undefined) {
        params.skip = filters.skip;
    }
    if (filters?.limit !== undefined) {
        params.limit = filters.limit;
    }

    return apiClient<User[]>("/users", {
        method: "GET",
        params,
    });
}

/**
 * Get a single user by ID
 */
export async function getUser(userId: string): Promise<User> {
    return apiClient<User>(`/users/${userId}`, {
        method: "GET",
    });
}

